/**
 * @generated SignedSource<<146f70c2cf3880811baaa4e975cf899c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type topPicksWidgetContent$data = {
  readonly entityId: string;
  readonly " $fragmentType": "topPicksWidgetContent";
};
export type topPicksWidgetContent$key = {
  readonly " $data"?: topPicksWidgetContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"topPicksWidgetContent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "topPicksWidgetContent",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityId",
      "storageKey": null
    }
  ],
  "type": "Article",
  "abstractKey": null
};

(node as any).hash = "b943ee3fed0cd0fd887ff415b3dc6877";

export default node;
